import { Button, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { FaApple, FaGooglePlay } from "react-icons/fa"

export function AppleStoreButton({ dark }) {
  return (
    <Button
      variant="contained"
      disableElevation
      href={"https://apps.apple.com/ng/app/wallx-africa/id1575698575"}
      target="_blank"
      sx={{
        color: dark ? "white" : "black",
        bgcolor: dark ? "black" : "white",
        textTransform:"capitalize",
        textDecoration:"none",
        ":hover": {
          color: dark ? "white" : "black",
          bgcolor: dark ? "black" : "white",
        },
      }}
      startIcon={<FaApple size={"32px"} />}
    >
      <Box textAlign={"left"}>
        <Typography fontWeight={"300"} fontSize="0.8em"noWrap  > 
          Download on the
        </Typography>
        <Typography fontSize={"1.2em"} fontWeight={"600"}noWrap>
          App Store
        </Typography>
      </Box>
    </Button>
  )
}

export function PlayStoreButton({ light }) {
  return (
    <Button
      variant="outlined"
      disableElevation
      href={"https://play.google.com/store/apps/details?id=co.wallx.android"}
      target="_blank"
      sx={{
        color: light ? "white" : "black",
        borderColor: light ? "white" : "black",
        textDecoration:"none",
        textTransform:"capitalize",
        ":hover": {
          color: light ? "white" : "black",
          borderColor: light ? "white" : "black",
        },
      }}
      startIcon={<FaGooglePlay size={"32px"} />}
    >
      <Box textAlign={"left"}>
        <Typography fontWeight={"300"} fontSize="0.8em" noWrap> 
          Download on the
        </Typography>
        <Typography fontSize={"1.2em"} fontWeight={"600" }noWrap >
          Google Play
        </Typography>
      </Box>
    </Button>
  )
}
